import { Box, Flex, Img } from '@chakra-ui/react'
import React from 'react'
import TypeWriter from './TypeWriter'

const HeroContent = () => {
  return (
    <Box
    display={"flex"}
    flexDir={["column","column","row"]}
    justifyContent={["center","center","space-around"]}
    alignItems="center"
    h={"100%"}
    gap="18px"
    
    >
        <TypeWriter/>
        <Img alt="gif"   src="herogif.gif" w={["200px","250px","400px"]} />

    </Box>
  )
}

export default HeroContent